import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";
import { Icon } from "@iconify/react/dist/iconify.js";

import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import "./ExtractSales.css";
import Loader from "../Components/Loader";
import { filteredCampaign } from "../Store/Actions/QAAction";

import {
  extractSales,
  filteredApplicationType,
  filteredExtractFormat,
} from "../Store/Actions/ReportAction";

export default function ExtractSales() {
  const [applicationTypeData, setApplicationTypeData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [displayValues, setDisplayValues] = useState({ campaign: [] });
  const [extractFormatData, setExtractFormatData] = useState([]);
  const { myInfo } = useSelector((state) => state.auth);

  const initialParams = {
    campaign: "",
    endDate: moment(),
    extractFormatID: null,
    isExtractAll: myInfo.user.AgentTSS.AgentCode !== "admin" ? false : true,
    productID: null,
    startDate: moment().subtract(1, "months"),

    updateExtractTime:
      myInfo.user.AgentTSS.AgentCode !== "admin" ? true : false,
  };

  const [extractFormatName, setExtractFormatName] = useState("");
  const [extractParams, setExtractParams] = useState(initialParams);
  const [isExtracting, setIsExtracting] = useState(false);
  const [isHeaderIncluded, setIsHeaderIncluded] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [outputFormat, setOutputFormat] = useState("tab");
  const [outputTypeFormat, setOutputTypeFormat] = useState("text");
  const [productName, setProductName] = useState("");

  // Run on first load, get search options data
  useEffect(() => {
    filteredApplicationType()
      .then((response) => {
        if (response.status) {
          setApplicationTypeData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    filteredCampaign({ agentid: myInfo.user.AgentTSS.AgentID })
      .then((response) => {
        if (response.status) {
          setCampaignData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    filteredExtractFormat()
      .then((response) => {
        if (response.status) {
          setExtractFormatData(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsExtracting(true);

    extractSales({
      campaign: extractParams.campaign,
      extractformatid: extractParams.extractFormatID,
      isextractall: extractParams.isExtractAll,

      perioddate: `${moment(extractParams.startDate).format(
        "MM/DD/yyyy"
      )}-${moment(extractParams.endDate).format("MM/DD/yyyy")}`,

      productid: extractParams.productID,
      updateextracttime: extractParams.updateExtractTime,
    })
      .then((response) => {
        if (response.status) {
          console.log("Extract: ", response.data);

          let filename = `Extracted_Sales_${extractFormatName}_${moment(
            extractParams.startDate
          ).format("MM/DD/yyyy")}-${moment(extractParams.endDate).format(
            "MM/DD/yyyy"
          )}_${productName}`;

          if (outputTypeFormat === "text") {
            // Create a text file with the extracted data
            const delimiter =
              outputFormat === "tab"
                ? "\t"
                : outputFormat === "pipe"
                ? "|"
                : outputFormat === "comma"
                ? ","
                : "";

            const header = isHeaderIncluded
              ? Object.keys(response.data[0]).join(delimiter) + "\n"
              : "";

            const rows = response.data
              .map((row) =>
                Object.values(row)
                  .map((value) => (value ? value.toString() : ""))
                  .join(delimiter)
              )
              .join("\n");

            const blob = new Blob([header + rows], {
              type: "text/plain;charset=utf-8",
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${filename}.txt`;

            link.click();
          } else {
            // Create worksheet
            const worksheet = XLSX.utils.json_to_sheet(response.data);

            // Create workbook
            const workbook = XLSX.utils.book_new();

            // Append worksheet to workbook, and name the worksheet "Extracted Sales"
            XLSX.utils.book_append_sheet(
              workbook,
              worksheet,
              "Extracted Sales"
            );

            const columns = Object.keys(response.data[0]);

            // Rename the columns
            XLSX.utils.sheet_add_aoa(worksheet, [columns], {
              origin: "A1",
            });

            // Calculate max width for each column
            const calculateMaxWidth = (column) => {
              return response.data.reduce((prev, curr) => {
                if (curr[column]) {
                  return Math.max(prev, curr[column].length);
                } else {
                  return 10;
                }
              }, 10);
            };

            const maxColumnWidths = columns.map((column) =>
              calculateMaxWidth(column)
            );

            worksheet["!cols"] = maxColumnWidths.map((width) => ({
              wch: width,
            }));

            // Write the file and save
            XLSX.writeFile(workbook, `${filename}.xlsx`, { compression: true });
          }

          setIsExtracting(false);
        } else {
          console.log("error", response.error);

          toast.error(response.error, {
            autoClose: 3000,
          });

          setIsExtracting(false);
        }
      })
      .catch((err) => {
        console.log("err", err);

        toast.error(err, {
          autoClose: 3000,
        });

        setIsExtracting(false);
      });
  };

  return (
    <div className="extract-sales">
      <div className="list_header">
        <div className="list_headerLeft">
          <div className="campaign-name">
            <h1>Extract Sales</h1>
          </div>
        </div>
      </div>

      <div className="containerExtractSales">
        <div className="extract-sales-contents dialog">
          {isLoading ? (
            <Loader />
          ) : (
            <form method="post" onSubmit={handleSubmit}>
              <div className="dialog-content">
                <div className="forms">
                  <section className="application-filter">
                    <div className="separator">
                      <Button disabled variant="outlined">
                        Application Filter
                      </Button>

                      <hr />
                    </div>

                    <div className="form-inputs">
                      <div className="item">
                        <TextField
                          fullWidth
                          label="Extract Format"
                          required
                          select
                          value={extractParams.extractFormatID}
                          onChange={(event) =>
                            setExtractParams({
                              ...extractParams,
                              extractFormatID: event.target.value,
                            })
                          }
                        >
                          {extractFormatData.map((data) => (
                            <MenuItem
                              key={data.ExtractFormatID}
                              value={data.ExtractFormatID}
                              onClick={() => {
                                setExtractFormatName(data.ExtractFormatName);
                              }}
                            >
                              {data.ExtractFormatName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>

                      <div className="item">
                        <TextField
                          fullWidth
                          label="Product"
                          required
                          select
                          value={extractParams.productID}
                          onChange={(event) =>
                            setExtractParams({
                              ...extractParams,
                              productID: event.target.value,
                            })
                          }
                        >
                          {applicationTypeData.map((data) => (
                            <MenuItem
                              key={data.ApplicationTypeID}
                              value={data.ApplicationTypeID}
                              onClick={() => {
                                setProductName(data.ApplicationTypeName);
                              }}
                            >
                              {data.ApplicationTypeName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>

                      <div className="item">
                        <Autocomplete
                          filterSelectedOptions
                          multiple
                          options={campaignData}
                          value={displayValues.campaign}
                          getOptionLabel={(campaign) => campaign.Name}
                          onChange={(event, value) => {
                            setExtractParams({
                              ...extractParams,
                              campaign: value?.length
                                ? value.map((val) => val.ID)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              campaign: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Campaign" />
                          )}
                        />
                      </div>

                      <div className="item date-range">
                        <DatePicker
                          disableFuture
                          label="Start Date"
                          maxDate={extractParams.endDate}
                          value={extractParams.startDate}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(newValue) =>
                            setExtractParams({
                              ...extractParams,
                              startDate: newValue,
                            })
                          }
                        />

                        <Icon
                          color="#7E7E7E"
                          icon="mdi:arrow-expand"
                          width="24"
                        />

                        <DatePicker
                          disableFuture
                          label="End Date"
                          minDate={extractParams.startDate}
                          value={extractParams.endDate}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(newValue) =>
                            setExtractParams({
                              ...extractParams,
                              endDate: newValue,
                            })
                          }
                        />
                      </div>
                    </div>
                  </section>

                  <section className="output">
                    <div className="separator">
                      <Button disabled variant="outlined">
                        Output
                      </Button>

                      <hr />
                    </div>

                    <div className="form-inputs">
                      <div className="item">
                        <TextField
                          fullWidth
                          label="Output Type Format"
                          select
                          value={outputTypeFormat}
                          onChange={(event) =>
                            setOutputTypeFormat(event.target.value)
                          }
                        >
                          <MenuItem value="text">Text File</MenuItem>
                          <MenuItem value="excel">Excel</MenuItem>
                        </TextField>
                      </div>

                      {outputTypeFormat !== "excel" && (
                        <>
                          <div className="item">
                            <TextField
                              fullWidth
                              label="Output Format"
                              select
                              value={outputFormat}
                              onChange={(event) =>
                                setOutputFormat(event.target.value)
                              }
                            >
                              <MenuItem value="tab">Tab Delimiter</MenuItem>
                              <MenuItem value="pipe">Pipe Delimiter</MenuItem>

                              <MenuItem value="comma">
                                Comma Separated Value
                              </MenuItem>

                              <MenuItem value="no">No Delimiter</MenuItem>
                            </TextField>
                          </div>

                          <FormGroup className="include-header">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isHeaderIncluded}
                                  color="default"
                                  onChange={(event) =>
                                    setIsHeaderIncluded(event.target.checked)
                                  }
                                />
                              }
                              label="Include Header"
                            />
                          </FormGroup>
                        </>
                      )}
                    </div>
                  </section>

                  <section className="extract-parameter">
                    <div className="separator">
                      <Button disabled variant="outlined">
                        Extract Parameter
                      </Button>

                      <hr />
                    </div>

                    <div className="form-inputs">
                      <div className="toggle">
                        <p>All Unextracted Application</p>

                        <Switch
                          checked={extractParams.isExtractAll}
                          disabled={myInfo.user.AgentTSS.AgentCode !== "admin"}
                          onChange={(event) =>
                            setExtractParams({
                              ...extractParams,
                              isExtractAll: event.target.checked,
                            })
                          }
                        />

                        <p>All Application</p>
                      </div>

                      <FormGroup className="include-header">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="default"
                              checked={extractParams.updateExtractTime}
                              disabled={
                                myInfo.user.AgentTSS.AgentCode !== "admin"
                              }
                              onChange={(event) =>
                                setExtractParams({
                                  ...extractParams,
                                  updateExtractTime: event.target.checked,
                                })
                              }
                            />
                          }
                          label="Update Last Extract Time"
                        />
                      </FormGroup>
                    </div>
                  </section>
                </div>
              </div>

              <section className="buttons">
                <button
                  className="confirm"
                  disabled={isExtracting}
                  type="submit"
                >
                  <Icon height="20" icon="fluent:script-20-filled" />
                  Extract Sales
                </button>
              </section>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
